interface EqxLoadingProps {
    size?: 'sm'
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
    inline?: boolean
    message?: string
}
const EqxLoading = function (props: EqxLoadingProps) {
    const fs = 'fs-5'
    const content = (
        <>
            <span
                className={
                    fs +
                    ' spinner-border ' +
                    (props.variant ? ' text-' + props.variant : '') +
                    (props.size ? 'spinner-border-' + props.size : '')
                }
                role="status"
            >
            </span>
        </>
    )
    console.log("Loading...", props.message)
    if (props.inline) return <span className="eqx-loading">{content}</span>
    return <div className={'eqx-loading text-center ' + (props.size != 'sm' ? 'p-5' : '')}>{content}{props.message && <div className="eqx-loading-message text-muted">{props.message}</div>}</div>
}
export default EqxLoading
